import { newAlertify } from 'trunks/vue/admin/components/alert.js'
import NamespacesContainer from './namespaces_container.js'

const emptyForm = () => ({
  name: '',
  site_name: '',
  appid: '',
  appsecret: '',
  template_message_id: '',
  remote_responder_uri: '',
  remote_responder_token: '',
  short_url_in_sms: false,
  enable_custom_favicon: false,
  features: [],
  jwt_data: {
    secret: '',
    cid: '',
    additional_data: ''
  }
})

export default Vue.extend({
  components: {
    'namespaces-container': NamespacesContainer
  },

  props: {
    mode: {
      type: String,
      default: 'new'
    },
    initialNamespace: {
      type: Object,
      default: null
    },
    features: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      form: this._buildForm(this.initialNamespace),
      saving: false,
      errors: []
    }
  },

  computed: {
    isEdit() {
      return this.mode === 'edit'
    },

    title() {
      return this.isEdit ? `编辑空间 - ${this.initialNamespace ? this.initialNamespace.name : ''}` : '新建空间'
    }
  },

  template: `
    <namespaces-container :title="title">
      <template slot="content">
        <div class="namespace-form">
          <div class="panel-card">
            <div class="panel-card-head">
              <span class="panel-card-title">基本信息</span>
            </div>
            <div class="panel-card-body">
              <div class="form-field required">
                <div class="form-field-head">
                  <div class="form-field-title">名字</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.name" class="form-field-value" type="text" placeholder="请输入空间名称" />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">空间后缀名</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.site_name" class="form-field-value" type="text" placeholder="不填则为 Skylark" />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">APPID</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.appid" class="form-field-value" type="text" />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">APPSECRET</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.appsecret" class="form-field-value" type="text" />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">模板消息 ID</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.template_message_id" class="form-field-value" type="text" />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">转发微信请求地址</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.remote_responder_uri" class="form-field-value" type="text" placeholder="https://..." />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">转发微信请求 Token</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.remote_responder_token" class="form-field-value" type="text" />
                  </div>
                </div>
              </div>

              <div class="form-field toggle-field">
                <label>
                  <input type="checkbox" v-model="form.short_url_in_sms" />
                  <span class="form-field-title-inline">在短信中添加短链接</span>
                </label>
              </div>

              <div class="form-field toggle-field">
                <label>
                  <input type="checkbox" v-model="form.enable_custom_favicon" />
                  <span class="form-field-title-inline">使用自定义站点图标</span>
                </label>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">开启的功能</div>
                </div>
                <div class="form-field-input-container features-checkboxes">
                  <label v-for="feature in features" :key="feature.id" class="feature-checkbox">
                    <input type="checkbox" :value="feature.id" v-model="form.features" />
                    <span>{{ feature.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="panel-card">
            <div class="panel-card-head">
              <span class="panel-card-title">JWT 设置</span>
            </div>
            <div class="panel-card-body">
              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">Secret</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.jwt_data.secret" class="form-field-value" type="text" />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">CID</div>
                </div>
                <div class="form-field-input-container">
                  <div class="form-field-input">
                    <input v-model.trim="form.jwt_data.cid" class="form-field-value" type="text" />
                  </div>
                </div>
              </div>

              <div class="form-field">
                <div class="form-field-head">
                  <div class="form-field-title">Additional Data (JSON)</div>
                </div>
                <div class="form-field-input-container">
                  <textarea v-model="form.jwt_data.additional_data" class="form-field-value" rows="3" placeholder='{"key": "value"}'></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="form-error-list" v-if="errors.length > 0">
            <div class="form-error-message" v-for="(message, idx) in errors" :key="idx">{{ message }}</div>
          </div>

          <div class="namespace-form-actions">
            <button class="btn btn-default outlined" @click="cancel">取消</button>
            <button class="btn btn-primary" :disabled="saving" @click="save">{{ saving ? '保存中...' : '保存' }}</button>
          </div>
        </div>
      </template>
    </namespaces-container>
  `,

  methods: {
    _buildForm(namespace) {
      if (!namespace) return emptyForm()

      const jwtData = namespace.jwt_data || {}
      return {
        name: namespace.name || '',
        site_name: namespace.site_name || '',
        appid: namespace.appid || '',
        appsecret: namespace.appsecret || '',
        template_message_id: namespace.template_message_id || '',
        remote_responder_uri: namespace.remote_responder_uri || '',
        remote_responder_token: namespace.remote_responder_token || '',
        short_url_in_sms: !!namespace.short_url_in_sms,
        enable_custom_favicon: !!namespace.enable_custom_favicon,
        features: (namespace.features || []).slice(),
        jwt_data: {
          secret: jwtData.secret || '',
          cid: jwtData.cid || '',
          additional_data: jwtData.additional_data || ''
        }
      }
    },

    cancel() {
      if (this.isEdit && this.initialNamespace) {
        Turbolinks.visit(`/admin/namespaces/${this.initialNamespace.id}`)
      } else {
        Turbolinks.visit('/admin/namespaces')
      }
    },

    save() {
      if (!this._validate()) return

      this.saving = true
      this.errors = []
      const payload = { namespace: this._payload() }
      const url = this.isEdit ? `/admin/namespaces/${this.initialNamespace.id}` : '/admin/namespaces'
      const method = this.isEdit ? 'patch' : 'post'

      Skylark.Libs.Ajax[method](url, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: payload,
        success: (data) => {
          newAlertify(this.isEdit ? '空间更新成功' : '空间创建成功', { type: 'success' })
          Turbolinks.visit(`/admin/namespaces/${data.id}`)
        },
        error: (xhr) => {
          const errors = xhr && xhr.responseJSON && xhr.responseJSON.errors
          this.errors = errors ? (Array.isArray(errors) ? errors : [errors]) : ['保存失败，请重试']
          newAlertify(this.errors[0], { type: 'error' })
        },
        complete: () => {
          this.saving = false
        }
      })
    },

    _payload() {
      return {
        name: this.form.name,
        site_name: this.form.site_name,
        appid: this.form.appid,
        appsecret: this.form.appsecret,
        template_message_id: this.form.template_message_id,
        remote_responder_uri: this.form.remote_responder_uri,
        remote_responder_token: this.form.remote_responder_token,
        short_url_in_sms: this.form.short_url_in_sms,
        enable_custom_favicon: this.form.enable_custom_favicon,
        features: this.form.features,
        jwt_data: {
          secret: this.form.jwt_data.secret,
          cid: this.form.jwt_data.cid,
          additional_data: this.form.jwt_data.additional_data
        }
      }
    },

    _validate() {
      this.errors = []
      if (!this.form.name) {
        this.errors.push('请填写空间名字')
      }
      return this.errors.length === 0
    }
  }
})
